
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/diviner-academy",
      function () {
        return require("private-next-pages/diviner-academy/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/diviner-academy"])
      });
    }
  